import FullWidthLayout from "@/layouts/FullWidthLayout";
import { KPageIndex } from "kinnect-general";
import { Pageable } from "kinnect-mixins";

export default {
	name: "YardReportsPage",

	metaInfo: { title: "Yard - Reports" },

	mixins: [ Pageable ],

	data: () => ( {
		items: [
			{
				title: "Delivery Notes",
				icon: "assignment_turned_in",
				to: { name: "yardDeliveryNotesReport" }
			},
			{
				title: "Drivers",
				icon: "person",
				to: { name: "yardDriversReport" }
			},
			{
				title: "Trucks",
				icon: "local_shipping",
				to: { name: "yardTrucksReport" }
			},
			{
				title: "Rental Pickups",
				icon: "transfer_within_a_station",
				to: { name: "yardRentalPickupsReport" }
			}
		]
	} ),

	render() {
		return <FullWidthLayout>
			<KPageIndex items={this.items}></KPageIndex>
		</FullWidthLayout>;
	}
};
